module.exports = "<app-header></app-header>\r\n\r\n<section class=\"full_width_background bg_img bgi01 clearfix\" id=\"subHeader\">\r\n\t<h1 class=\"text-white\">UIK - Universal Interactive Kit</h1>\r\n\t<h3 class=\"text-white m-b-20\">Feature - Forms</h3>\r\n</section>\r\n\r\n<section class=\"full_width_background clearfix\" id=\"content\">\r\n\t<div class=\"container-fluid\">\r\n\t\t<app-form1></app-form1>\r\n\t\t<app-form2></app-form2>\r\n\t</div>\r\n</section>\r\n\r\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/form/form.component.html
// module id = ./src/app/features/form/form.component.html
// module chunks = main